import { FC, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MENUITEM_IDS } from '@/lib';
import { EmailEditorForm } from '@/features/email-flows/emails/components';
import { EmailEditorLayout } from '@/features/email-flows/components/layout/EmailEditorLayout';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useStanRouter } from '@/hooks/useStanRouter';

const AddEmailPage: FC = () => {
    const { flowId } = useParams<{ flowId: string }>();
    const location = useLocation();
    const { push } = useStanRouter();

    // Parse and validate flowId
    const parsedFlowId = Number(flowId) || -1;
    useEffect(() => {
        if (parsedFlowId === -1) {
            push('/flows');
        }
    }, [parsedFlowId, push]);

    useBreadcrumbs([
        { title: 'My Email Flows', to: '/flows', id: MENUITEM_IDS.FLOWS, active: false },
        { title: 'Flows', to: `/flows?tab=flows`, id: 'flows-tab', active: true },
    ]);

    // Don't render if flowId is invalid
    if (parsedFlowId === -1) {
        return null;
    }

    return (
        <EmailEditorLayout flowId={parsedFlowId}>
            <EmailEditorForm key={`${flowId}-${location.key}`} flowId={parsedFlowId} />
        </EmailEditorLayout>
    );
};

export default AddEmailPage;
